export const Agent = ({ x, y, name }) => {
  return (
    <div
      style={{
        position: "absolute",
        transition: "all 3s ease-in-out",
        left: x,
        top: y,
        width: 48,
        height: 48,
        backgroundImage: `url(/images/agents/${name}.png)`,
        backgroundSize: "cover",
      }}
    />
  );
};
